import Message from 'carbon-react/lib/components/message';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const SyncLoadingMessage = () => (
  <div style={{ marginTop: 24 }} data-testid="syncing-message">
    <Message
      title={
        <FormattedMessage
          id="predict.common.sync__we_will_notify"
          defaultMessage="We’ll notify you when the sync is complete"
        />
      }
    >
      <FormattedMessage
        id="predict.common.sync_you_can_continue"
        defaultMessage="You can continue to use the app in the meantime."
      />
    </Message>
  </div>
);
